import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(({ spacing, palette }) => ({
  productNotesContainer: {
    display: "flex",
    margin: spacing(2, 0, 1),
    justifyContent: "space-between",
    alignItems: "center",
    maxHeight: "42px",
  },
  attachmentInput: {
    display: "none",
  },
  emptyAttachmentsButton: {
    color: grey[500],
    textAlign: "center",
  },
  input: {
    paddingTop: spacing(0.5),
    paddingBottom: spacing(0.5),
    height: "auto",
    maxWidth: "100%",
  },
  labelFormControl: {
    right: spacing(2.125),
    color: palette.contrastText.main,
  },
}));
